import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface SuccessGreenTickIcon {
  width?: string;
  height?: number;
}

const SuccessGreenTickIcon: React.FC<SuccessGreenTickIcon> = ({
  height = 56,
  width = 56,
  ...props
}) => {
  return (
    <SVGUniqueID>
      <svg
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          fill="#36B37E"
          fillRule="evenodd"
          d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z"
          clipRule="evenodd"
          opacity={0.15}
        />
        <path
          fill="#36B37E"
          d="M10.398 15.824l-3.261-3.242A.476.476 0 017 12.23c0-.143.046-.26.137-.351l.722-.703a.437.437 0 01.342-.156c.137 0 .257.052.361.156l2.188 2.187 4.688-4.687a.495.495 0 01.36-.156c.137 0 .251.052.343.156l.722.703A.475.475 0 0117 9.73c0 .144-.046.26-.137.352l-5.761 5.742c-.092.104-.209.156-.352.156s-.26-.052-.352-.156z"
        />
      </svg>
    </SVGUniqueID>
  );
};

export default SuccessGreenTickIcon;
